import { NgModule } from '@angular/core';
// eslint-disable-next-line no-restricted-imports
import {
  MatPaginatorIntl,
  MatPaginatorModule,
} from '@angular/material/paginator';

import { AppPaginatorIntl } from '@main-client/src/app/ttc-mat-paginator/ttc-mat-paginator';

@NgModule({
  imports: [MatPaginatorModule],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: AppPaginatorIntl,
    },
  ],
  exports: [MatPaginatorModule],
})
export class TtcMatPaginatorModule {}
